import { makeStyles, Typography, useTheme } from '@material-ui/core'
import { styles } from './pageHeader.styles'
import React from 'react'
import { useDocTitle } from '../../hooks'

export interface PageHeaderProps {
  title: string
  subtitle?: string
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, ...props }) => {
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()
  useDocTitle(title)

  return (
    <div className={classes.pageHeader}>
      <div className={classes.titles}>
        <Typography variant="h1" color="secondary">
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="subtitle2" color="secondary">
            {subtitle}
          </Typography>
        )}
      </div>
      <div className={classes.mainActions}>{props.children}</div>
    </div>
  )
}

export default PageHeader
